// src/utils/identity.js
import { ref, get } from "firebase/database";
import { db } from "../firebase";

const DOMAIN = "vnrvjiet.in";
const b64 = (s) => btoa((s || "").toLowerCase());

/** Derive ROLL from a Google email (domain or exception). Uppercase roll. */
export async function getRollFromEmail(email) {
  if (!email) return "";
  const low = email.toLowerCase();
  if (low.endsWith(`@${DOMAIN}`)) return low.split("@")[0].toUpperCase();
  // exception email -> roll
  const snap = await get(ref(db, `exceptionsByEmail/${b64(low)}`));
  return snap.exists() ? String(snap.val() || "").toUpperCase() : "";
}

/** Resolve preferred email for a given roll: exception email OR roll@vnrvjiet.in */
export async function getPreferredEmailForRoll(roll) {
  if (!roll) return "";
  const r = roll.toUpperCase();
  const ex = await get(ref(db, `exceptionsByRoll/${r}`));
  if (ex.exists() && ex.val()?.e) return String(ex.val().e).toLowerCase();
  return `${r.toLowerCase()}@${DOMAIN}`;
}

/** Resolve preferred email for a Google email: uses exception mapping if needed. */
export async function getPreferredEmailForEmail(email) {
  const roll = await getRollFromEmail(email);
  return roll ? getPreferredEmailForRoll(roll) : "";
}
